<template>
  <div id="componentDialog">
    <div id="circle"></div>
    <div id="contentsContainer">
      <div id="ciImgContainer">
        <img id="ciBothImg" src="../../../assets/b2b/dlcon/ci_dlcon.png" />
      </div>
      <div id="inputContainer">
        <input
            id="inputId"
            v-model="id"
            @keyup.enter="enterId"
            type="email"
            name="email"
            class="inputItem"
            placeholder="이메일"
            style="margin-bottom: 12px;"
        >
        <input
            id="inputPw"
            v-model="pw"
            @keyup.enter="enterPw"
            type="password"
            class="inputItem"
            placeholder="패스워드"
        >
      </div>
    </div>

    <div id="loginButton" @click="onLoginButton">
      LOGIN
    </div>

    <popup-dialog-component v-if="showDlconLoginFailedPopup" />
  </div>
</template>

<script>
import PopupDialogComponent from "./PopupDialogComponent";
import { mapState, mapMutations } from "vuex";
import {api} from "../../../mixins/api";


export default {
  name: "LoginComponent",
  components: {PopupDialogComponent},
  data() {
    return {
      id: null,
      pw: null,
    }
  },
  computed: {
    ...mapState(["showDlconLoginFailedPopup"]),
  },
  methods: {
    ...mapMutations(["setShowDlconLoginFailedPopup"]),
    enterId() {
      document.getElementById('inputPw').focus();
    },
    enterPw() {
      this.onLoginButton()

    },
    async onLoginButton() {
      let response = await api.methods.loginIdPassword(this.id, this.pw, 'dlcon');
      if (response && response.status === 200) {
        this.$store.commit("setRefreshToken", response.data);
        alert('로그인 되었습니다.');
        await this.$router.replace('/dlcon/b2b_market_trend_dashboard_01%2Fb2b_market_trend_dashboard_01_main_01');
      } else {
        this.setShowDlconLoginFailedPopup(true);
      }
    }
  }
}
</script>

<style scoped>
#componentDialog {
  overflow: hidden;
  position: relative;
  width: 610px;
  height: 435px;
  background: linear-gradient(124.95deg, #202020 -25.79%, #333333 71.35%);
  box-shadow: 0px 3.16444px 23.7333px rgba(0, 0, 0, 0.1);
  border-radius: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 68px 80px 48px;
}

#contentsContainer {
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

#circle {
  /*display: none;*/
  position: absolute;
  width: 857.56px;
  height: 674.03px;
  left: -71.99px;
  top: -336.22px;
  background: linear-gradient(180deg, #333333 0%, rgba(51, 51, 51, 0.8) 100%);
  border-radius: 100%;
  z-index: 0;
}

#ciImgContainer {
  width: 100%;
  background-color: #FFFFFF;
  text-align: center;
}

#ciBothImg {
  width: 250px;
  border-radius: 80px;
  background-color: #FFFFFF;
  /*height: 60px;*/
}

#inputContainer {
  margin: 24px 0 32px;
  color: red;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.474667px;
}

.inputItem {
   padding: 20px 0px 20px 20px;
  width: 450px;
  height: 58px;
  background: #424242;
  border-radius: 10px;
  color: #FFFFFF;
  letter-spacing: -0.474667px;
  font-size: 18px;
  line-height: 18px;
}

.inputItem::placeholder {
  color: #A5A5A5;
}

#loginButton {
  width: 172px;
  height: 50px;
  background: #FFFFFF;
  align-items: center;
  border-radius: 100px;
  padding: 16px 60px;
  align-self: flex-end;
  font-size: 18px;
  line-height: 18px;
  color: #333333;
  letter-spacing: -0.474667px;
  cursor: pointer;
}

#loginButton:hover{
  background-color: rgba(255, 255, 255, 0.8);
}

</style>
